var _a, _b;
import * as tslib_1 from "tslib";
import { reduxKey } from './constants';
import { PUBLISH_COMMENT, PUBLISH_COMMENT_SUCCESS, EDITOR_CHANGED, PUBLISH_COMMENT_FAILURE, focusEditor, focusDone, } from './actionCreators';
import ddt from '@wix/da-ddt';
var actionHandlers = (_a = {},
    _a[PUBLISH_COMMENT] = function (state, action) { return (tslib_1.__assign({}, state, { isBusy: true, publishResult: null, isError: false, errorMsg: null })); },
    _a[PUBLISH_COMMENT_SUCCESS] = function (state, action) { return (tslib_1.__assign({}, state, { isBusy: false, publishResult: action.payload, isError: false, errorMsg: null })); },
    _a[PUBLISH_COMMENT_FAILURE] = function (state, action) {
        ddt.log('comments', 'Failed to post comment', action);
        return tslib_1.__assign({}, state, { isBusy: false, publishResult: null, isError: true, errorMsg: action.payload.errorMsg });
    },
    _a[EDITOR_CHANGED] = function (state, action) { return (tslib_1.__assign({}, state, { isBusy: false, publishResult: null, isError: false, errorMsg: null })); },
    _a[focusEditor.toString()] = function (state, action) { return (tslib_1.__assign({}, state, { focus: true })); },
    _a[focusDone.toString()] = function (state, action) { return (tslib_1.__assign({}, state, { focus: false })); },
    _a);
var reducers = (_b = {},
    _b[reduxKey] = function (state, action) {
        var _a;
        if (state === void 0) { state = {}; }
        if (!actionHandlers[action.type]) {
            return state;
        }
        var editorId = action.payload.editorId;
        if (!editorId) {
            return state;
        }
        var innerState = state[editorId];
        var newInnerState = actionHandlers[action.type](innerState, action);
        return tslib_1.__assign({}, state, (_a = {}, _a[editorId] = newInnerState, _a));
    },
    _b);
export default reducers;
//# sourceMappingURL=reducers.js.map